import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
    baseURL: API,
    headers: { "Content-Type": "application/json" },
});

export const GIVESENDGO_URL = "https://www.givesendgo.com/stateofdeception";
export const TRAILER_URL = "https://www.youtube.com/watch?v=meRtf3PMhlQ";
export const TRAILER_EMBED = "https://www.youtube.com/embed/meRtf3PMhlQ";
